import { useEffect, useState } from "react"
import AmountModeField from "../common/AmountModeField";
import { CheckNull, CurrencyConvertion, isNumberOnly, PriceCheck, QatarConvertion, calculateNetPrice } from "../../utils/Validate";

export const QuotationSummary = ({ values, setValues, FormatValueDecimal, currencyList, currencyDetail, qarCurrencyDetail, editQuotation, setQuotUserEntry,
    quotUserEntry }) => {
    const [quotationSummary, setQuotationSummary] = useState({});


    const [taxMode, setTaxMode] = useState('$');
    const [customDutyMode, setCustomDutyMode] = useState('$');
    const [clearnceMode, setClearnceMode] = useState('$');

    const HandleCustomDutyModeChange = () => {
        setCustomDutyMode((prevMode) => (prevMode === '$' ? '%' : '$'));
        setQuotUserEntry({ ...quotUserEntry, customDutyPercentage: 0, customDuty: 0 })
    };

    const HandleClearnceModeChange = () => {
        setClearnceMode((prevMode) => (prevMode === '$' ? '%' : '$'));
        setQuotUserEntry({ ...quotUserEntry, clearanceChargesPercentage: 0, clearanceCharges: 0 })
    };

    const HandleTaxModeChange = () => {
        setTaxMode((prevMode) => (prevMode === '$' ? '%' : '$'));
        setQuotUserEntry({ ...quotUserEntry, tax: 0, taxPercentage: 0 })
    };

    useEffect(() => {
        let totListPrice = 0;
        let totNetPrice = 0;

        values?.products?.forEach((item) => {
            const listPrice = parseFloat(item?.listPrice);
            const safeListPrice = isNaN(listPrice) ? 0 : listPrice;

            totListPrice += safeListPrice;
            totNetPrice += calculateNetPrice(item);
        });

        setQuotationSummary({
            ...quotationSummary,
            totalListPrice: totListPrice,
            netPrice: totNetPrice,
        });
    }, [values?.products]);

    useEffect(() => {
        const newValues = {
            ...values,
            totalListPrice: quotationSummary?.totalListPrice,
            netPrice: quotationSummary?.netPrice,
        };
        setValues(newValues);
    }, [quotationSummary]);

    const calculateTotalDdp = (item, freightCustoms) => {
        const sellingPrice = calculateNetPrice(item);

        if (freightCustoms >= 1) return 0;

        const ddpMultiplier = 1 - freightCustoms;

        const finalDdp = sellingPrice / (ddpMultiplier || 1);

        if (!Number.isFinite(finalDdp)) return 0;

        return finalDdp.toFixed(2);
    };

    useEffect(() => {
        const totalExworksPrice = (values?.netPrice * 1) + (values.specialCharges * 1)
        const customDutyValue = customDutyMode === '$' ? (values?.customDuty * 1) : (((totalExworksPrice * 1) + (values?.freightCharges * 1)) * ((values?.customDutyPercentage * 1) / 100))
        const clearnceValue = clearnceMode === '$' ? (values?.clearanceCharges * 1) : (((totalExworksPrice * 1) + (values?.freightCharges * 1) + (customDutyValue * 1)) * ((values?.clearanceChargesPercentage * 1) / 100))
        const totalLandedCost = ((totalExworksPrice * 1) + (values?.freightCharges * 1) + (customDutyValue * 1) + (clearnceValue * 1))
        // const salesMarginValue = ((totalLandedCost * 1) / (1 - (values?.salesMarginPercentage / 100)))
        const salesMarginValue = totalLandedCost * 1
        const taxValue = taxMode === '$' ? (values?.tax * 1) : ((salesMarginValue * 1) * ((values?.taxPercentage * 1) / 100))
        // const taxValue = taxMode === '$' ? (values?.tax * 1) : ((values?.taxPercentage * 1) / 100)
        const grandTotal = taxValue + salesMarginValue
        // const frieghtcustoms = (totalLandedCost - (values?.netPrice * 1))
        const freightCustoms =
            (totalLandedCost - values?.netPrice) / totalLandedCost;

        const productsArr = values?.products?.map((item) => {
            const totalDdp = calculateTotalDdp(item, freightCustoms);
            return { ...item, totalDdp };
        });

        setValues((prev) => ({
            ...prev,
            products: productsArr,
            totalSellingPrice: parseFloat(salesMarginValue),
            totalExworksPrice: parseFloat(totalExworksPrice),
            grandTotal: parseFloat(grandTotal),
            totalLandedCost: parseFloat(totalLandedCost),
        }));
    }, [
        values?.specialCharges,
        values?.netPrice,
        values?.customDuty,
        values?.customDutyPercentage,
        values?.freightCharges,
        values?.clearanceCharges,
        values?.clearanceChargesPercentage,
        // values?.salesMarginPercentage,
        values?.tax,
        values?.taxPercentage,
        clearnceMode, customDutyMode, taxMode
    ]);

    useEffect(() => {
        if (values?.customDuty > 0) setCustomDutyMode('$')
        else setCustomDutyMode('%')
        if (values?.tax > 0) setTaxMode('$')
        else setTaxMode('%')
        if (values?.clearanceCharges > 0) setClearnceMode('$')
        else setClearnceMode('%')
    }, [values.id])

    const HandleInputChange = (e) => {
        const { name, value } = e.target;
        setQuotUserEntry({ ...quotUserEntry, [name]: value || 0 })
    }

    useEffect(() => {
        setValues({
            ...values,
            specialCharges: QatarConvertion(quotUserEntry?.specialCharges, values?.conversionRate, currencyDetail) * 1 || 0,
            freightCharges: QatarConvertion(quotUserEntry?.freightCharges, values?.conversionRate, currencyDetail) * 1 || 0,
            customDuty: QatarConvertion(quotUserEntry?.customDuty, values?.conversionRate, currencyDetail) * 1 || 0,
            customDutyPercentage: (quotUserEntry?.customDutyPercentage) * 1 || 0,
            clearanceCharges: QatarConvertion(quotUserEntry?.clearanceCharges, values?.conversionRate, currencyDetail) * 1 || 0,
            clearanceChargesPercentage: (quotUserEntry?.clearanceChargesPercentage) * 1 || 0,
            // salesMarginPercentage: (quotUserEntry?.salesMarginPercentage)*1 || 0,
            tax: QatarConvertion(quotUserEntry?.tax, values?.conversionRate, currencyDetail) * 1 || 0,
            taxPercentage: (quotUserEntry?.taxPercentage) * 1 || 0
        })
    }, [quotUserEntry])

    return (
        <div className="card quotation-commercial-summary">
            <div className="card-header">
                <h5>{qarCurrencyDetail?.shortCode} : {FormatValueDecimal(CurrencyConvertion(values?.grandTotal, 1, qarCurrencyDetail))}</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="mb-2">
                            <label>Net price</label>
                            <input
                                className="form-control"
                                type="text"
                                name="netPrice"
                                placeholder="Enter"
                                value={FormatValueDecimal(CurrencyConvertion(values?.netPrice, 1, qarCurrencyDetail))}
                                disabled="true"
                                style={{ textAlign: "right" }}
                            ></input>
                        </div>
                        <div className="mb-2">
                            <label>Special color</label>
                            <input
                                autocomplete="off"
                                type="number"
                                name="specialCharges"
                                step=".01"
                                min="0"
                                className="form-control"
                                placeholder="Enter"
                                onChange={HandleInputChange}
                                value={quotUserEntry.specialCharges > 0 ? quotUserEntry.specialCharges : ""}
                                onkeypress={(e) => { return PriceCheck(e.target.value) }}
                                style={{ textAlign: "right" }}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                            />
                        </div>
                        <div className="mb-2">
                            <label>Total Ex-Works price</label>
                            <input
                                className="form-control"
                                type="text"
                                name="totalExworksPrice"
                                placeholder="Enter"
                                value={FormatValueDecimal(CurrencyConvertion(values?.totalExworksPrice, 1, qarCurrencyDetail))}
                                disabled="true"
                                style={{ textAlign: "right" }}
                            ></input>
                        </div>
                        <div className="mb-2">
                            <label>Frieght & delivery charges</label>
                            <input
                                autocomplete="off"
                                type="number"
                                name="freightCharges"
                                step=".01"
                                min="0"
                                className="form-control"
                                placeholder="Enter"
                                onChange={HandleInputChange}
                                value={quotUserEntry?.freightCharges > 0 ? quotUserEntry?.freightCharges : ""}
                                onkeypress={(e) => { return PriceCheck(e.target.value) }}
                                style={{ textAlign: "right" }}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                            />
                        </div>
                        <div className="mb-2">
                            <label>Custom Duty</label>
                            <AmountModeField
                                min="0"
                                mode={customDutyMode}
                                name={customDutyMode === '$' ? 'customDuty' : 'customDutyPercentage'}
                                onChange={HandleInputChange}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                onKeyPress={(e) => { return PriceCheck(e.target.value) }}
                                onModeToggle={HandleCustomDutyModeChange}
                                step=".01"
                                value={customDutyMode === '$' ? quotUserEntry?.customDuty > 0 ? quotUserEntry?.customDuty : "" :
                                    quotUserEntry?.customDutyPercentage > 0 ? quotUserEntry?.customDutyPercentage : ""}
                            />
                        </div>
                        <div className="mb-2">
                            <label>Clearance charges</label>
                            <AmountModeField
                                min="0"
                                mode={clearnceMode}
                                name={clearnceMode === '$' ? 'clearanceCharges' : 'clearanceChargesPercentage'}
                                onChange={HandleInputChange}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                onKeyPress={(e) => { return PriceCheck(e.target.value) }}
                                onModeToggle={HandleClearnceModeChange}
                                step=".01"
                                value={clearnceMode === '$' ? quotUserEntry?.clearanceCharges > 0 ? quotUserEntry?.clearanceCharges : "" :
                                    quotUserEntry?.clearanceChargesPercentage > 0 ? quotUserEntry?.clearanceChargesPercentage : ""}
                            />
                        </div>
                        <div className="mb-2">
                            <label>Total Landed Cost</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Enter"
                                name="totalLandedCost"
                                disabled="true"
                                value={values?.totalLandedCost > 0 ? FormatValueDecimal(CurrencyConvertion(values?.totalLandedCost, 1, qarCurrencyDetail)) : 0}
                                style={{ textAlign: "right" }}
                            // onChange={HandleInputChange}
                            ></input>
                        </div>
                        {/* <div className="mb-2">
                            <label>Sales Margin (%)</label>
                            <input
                                autocomplete="off"
                                type="number"
                                name="salesMarginPercentage"
                                step=".01"
                                min="0"
                                className="form-control"
                                placeholder="Enter"
                                onChange={HandleInputChange}
                                value={quotUserEntry?.salesMarginPercentage > 0 ? quotUserEntry?.salesMarginPercentage : ""}
                                onkeypress={(e) => { return PriceCheck(e.target.value) }}
                                style={{ textAlign: "right" }}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                            />
                        </div> */}
                        <div className="mb-2">
                            <label>Total Selling Price</label>
                            <input
                                className="form-control"
                                type="text"
                                name="totalSellingPrice"
                                placeholder="Enter"
                                value={FormatValueDecimal(CurrencyConvertion(values?.totalSellingPrice, 1, qarCurrencyDetail))}
                                disabled="true"
                                style={{ textAlign: "right" }}
                            ></input>
                        </div>
                        <div className="mb-2">
                            <label>Tax</label>
                            <AmountModeField
                                min="0"
                                mode={taxMode}
                                name={taxMode === '$' ? 'tax' : 'taxPercentage'}
                                onChange={HandleInputChange}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                onKeyPress={(e) => { return PriceCheck(e.target.value) }}
                                onModeToggle={HandleTaxModeChange}
                                step=".01"
                                value={taxMode === '$' ? quotUserEntry?.tax > 0 ? quotUserEntry?.tax : "" :
                                    quotUserEntry?.taxPercentage > 0 ? quotUserEntry?.taxPercentage : ""}
                            />
                        </div>
                        <div className="mb-0 quotation-grand-total-field">
                            <label>Grand Total</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Enter"
                                name="grandTotal"
                                disabled="true"
                                value={values?.grandTotal > 0 ? FormatValueDecimal(CurrencyConvertion(values?.grandTotal, 1, qarCurrencyDetail)) : 0}
                                style={{ textAlign: "right" }}
                            ></input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

